export default "__VITE_ASSET__75f05d3e__"